export const downloadFile = (blobUrl: string, fileName: string) => {
  const tempLink = document.createElement("a");
  tempLink.style.display = "none";
  tempLink.setAttribute("href", blobUrl);
  tempLink.setAttribute("download", fileName);

  if (typeof tempLink.download === "undefined") {
    tempLink.setAttribute("target", "_blank");
  }

  document.body.appendChild(tempLink);
  tempLink.click();

  setTimeout(function () {
    document.body.removeChild(tempLink);
  }, 200);
};

export const getBlobUrl = async (url: string) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};
